module.exports = __webpack_public_path__ + "assets/img/kv-235246e0.jpg";